import { FC, useState, ChangeEvent } from 'react';
import { v4 as uuid } from 'uuid';
// Redux
import { useAppDispatch } from 'hooks/useStore';
// Component
import { Button } from 'components/Buttons';
import { Input } from 'components/Controls';
// Selectors
import { setQuestionStart } from 'store/player/playerSlice';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  onSubmit: (answer:{ ref:string, title:string, correct?:boolean }) => void;
  disabled?: boolean;
};

const ScoreAnswers:FC<Props> = ({ onSubmit, disabled = false }) => {
  const { t } = useTranslation('common');
  const dispatch = useAppDispatch();

  const [ clicked, setClicked ] = useState<boolean>(false);

  const [ firstScore, setFirstScore ] = useState<string>('');
  const [ secondScore, setSecondScore ] = useState<string>('');

  const handleTitle = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'question-game-score-1') {
      setFirstScore(`${value}`);
    } else {
      setSecondScore(`${value}`);
    }
  }

  const handleSubmit = () => {
    if(clicked) return;
    onSubmit({
      ref: uuid(),
      title: `${firstScore}-${secondScore}`,
    });
    dispatch(setQuestionStart(false));
    setClicked(true);
  }

  return (
    <div>
      <div className="flex gap-4">
        <Input
          name="question-game-score-1" id="question-game-score-1" placeholder="Score 1"
          value={firstScore}
          onChange={handleTitle}
          disabled={disabled}
          type="number"
        />
        <Input
          name="question-game-score-2" id="question-game-score-2" placeholder="Score 2"
          value={secondScore}
          onChange={handleTitle}
          disabled={disabled}
          type="number"
        />
      </div>
      <Button
        className={`
          w-full font-normal normal-case mt-2 text-white
          hover:bg-none bg-primary hover:bg-primary
        `}
        onClick={handleSubmit}
        disabled={!firstScore.trim() || !secondScore.trim() || clicked}
      >
        {t('common.next')}
      </Button>
    </div>
  )
}

export default ScoreAnswers;
